<ng-container ngForm>
    <iframe #pingWidget [src]="iFrameSrc"></iframe>
</ng-container>
